import { isWeekend } from "date-fns";

export interface IEditorJsBlock {
  id: string;
  type: string;
  data: { text?: string; [key: string]: unknown };
}

export interface IEditorJsContent {
  time: number;
  blocks: IEditorJsBlock[];
  version: string;
}

export const isEditorJsContent = (value: unknown): value is IEditorJsContent => {
  return (
    !!value &&
    typeof value === 'object' &&
    Array.isArray((value as IEditorJsContent).blocks)
  );
};

export const parseCommentBlocks = (
  comment?: string | null
): IEditorJsBlock[] | null => {
  if (!comment) {
    return null;
  }

  try {
    const parsed = JSON.parse(comment);

    if (isEditorJsContent(parsed)) {
      return parsed.blocks;
    }
  } catch {
    return null;
  }

  return null;
};

export const sizeConverter = (size: number) => {
  switch(size) {
    case 14:
      return 'small'
    case 16:
      return 'default'
    case 18:
      return 'large'
    default: 
      return 'default'
  }
};

export const sizeInverseConverter = (size: string) => {
  switch(size) {
    case 'small':
      return 14
    case 'default':
      return 16
    case 'large':
      return 18
    default: 
      return 16
  }
};

export const essayTitle = (type: number) => {
  switch (type) {
    case 2:
      return 'ENEM';
    case 3:
      return 'FUVEST';
    case 4:
      return 'UNESP';
    case 5:
      return 'UNICAMP';
    case 6:
      return 'UFPR';
    case 7:
      return 'Gêneros'
    default:
      return 'ENEM';
  }
};

export const criteriaColor = (id: number): string => {
  switch(id) {
    case 1: 
      return "#9C0000";
    case 2: 
      return "#D81B60";
    case 3: 
      return "#7B1FA2";
    case 4: 
      return "#0D47A1";
    case 5: 
      return "#388E3C";
    case 6: 
      return "#827717";
    case 7: 
      return "#A94A00";
    case 8: 
      return "#004D40";
    case 9: 
      return "#9C0000";
    case 10: 
      return "#D81B60";
    case 11: 
      return "#7B1FA2";
    case 12: 
      return "#9C0000";
    case 13: 
      return "#D81B60";
    case 14: 
      return "#7B1FA2";
    case 15: 
      return "#0D47A1";
    case 16: 
      return "#9C0000";
    case 17: 
      return "#D81B60";
    case 19: 
      return "#7B1FA2";
    case 20: 
      return "#9C0000";
    case 21: 
      return "#D81B60";
    case 22: 
      return "#7B1FA2";
    case 23: 
      return "#827717";
    case 24: 
      return "#9C0000";
    case 25: 
      return "#D81B60";
    case 26: 
      return "#7B1FA2";
    case 27: 
      return "#0D47A1";
    case 28: 
      return "#388E3C";
    case 29:
      return "#74c2c2";
    case 35: 
      return "#9C0000";
    case 36: 
      return "#D81B60";
    case 37: 
      return "#7B1FA2";
    case 38: 
      return "#8259f0";
    default:
      return "#1B229F"
  }
};

export const criteriaName = (id: number) => {
  switch(id){
    case 1: 
      return "Competência 1";
    case 2: 
      return "Competência 2";
    case 3: 
      return "Competência 3";
    case 4: 
      return "Competência 4";
    case 5: 
      return "Competência 5";
    case 6: 
      return "ADEQUAÇÃO À PROPOSTA E GÊNERO";
    case 7: 
      return "DESENVOLVIMENTO DA PROPOSTA";
    case 8: 
      return "LINGUAGEM";
    case 9: 
      return "Tema";
    case 10: 
      return "Gênero/ Tipo de texto e coerência";
    case 11: 
      return "Elementos Linguísticos";
    case 12: 
      return "Proposta temática";
    case 13: 
      return "Gênero";
    case 14: 
      return "Leitura dos textos";
    case 15: 
      return "Convenções da escrita e coesão";
    case 16: 
      return "Desenvolvimento do tema e organização do texto dissertativo-argumentativo";
    case 17: 
      return "Coerência dos argumentos e articulação das partes do texto";
    case 19: 
      return "Correção gramatical e adequação vocabular";
    case 20: 
      return "Adequação à proposta (tema e gênero)";
    case 21: 
      return "Emprego da modalidade escrita na variedade padrão da língua portuguesa";
    case 22: 
      return "Coerência e coesão";
    case 23: 
      return "Nível de informatividade e de argumentação ou narratividade, de acordo com a proposta.";
    case 24: 
      return "Competência 1";
    case 25: 
      return "Competência 2";
    case 26: 
      return "Competência 3";
    case 27: 
      return "Competência 4";
    case 28: 
      return "Competência 5";
    case 29:
      return "Coesão";
    case 35: 
      return "Desenvolvimento do tema, uso da coletânea e autoria";
    case 36: 
      return "Compreensão e atendimento da proposta quanto ao gênero e tipo de texto";
    case 37: 
      return "Recursos linguísticos (coesão e coerência) e progressão textual";
    case 38: 
      return "Convenções da escrita e adequação vocabular";
    default:
      return "Indefinido"
  }  
};

export const criteriaNameInverse = (competencia: string) => {
  switch(competencia){
    case"Competência 1": 
      return  1;
    case"Competência 2": 
      return  2;
    case"Competência 3": 
      return  3;
    case"Competência 4": 
      return  4;
    case"Competência 5": 
      return  5;
    case"ADEQUAÇÃO À PROPOSTA E GÊNERO": 
      return  6;
    case"DESENVOLVIMENTO DA PROPOSTA": 
      return  7;
    case"LINGUAGEM": 
      return  8;
    case"Tema": 
      return  9;
    case "Gênero/ Tipo de texto e coerência": 
      return 10;
    case "Elementos Linguísticos": 
      return 11;
    case "Proposta temática": 
      return 12;
    case "Gênero": 
      return 13;
    case "Leitura dos textos": 
      return 14;
    case "Convenções da escrita e coesão": 
      return 15;
    case "Desenvolvimento do tema e organização do texto dissertativo-argumentativo": 
      return 16;
    case "Coerência dos argumentos e articulação das partes do texto": 
      return 17;
    case "Correção gramatical e adequação vocabular": 
      return 19;
    case "Adequação à proposta (tema e gênero)": 
      return 20;
    case "Emprego da modalidade escrita na variedade padrão da língua portuguesa": 
      return 21;
    case "Coerência e coesão": 
      return 22;
    case "Nível de informatividade e de argumentação ou narratividade, de acordo com a proposta.": 
      return 23;
    case "Coesão":
      return 29;
    case "Desenvolvimento do tema, uso da coletânea e autoria": 
      return 35;
    case "Compreensão e atendimento da proposta quanto ao gênero e tipo de texto": 
      return 36;
    case "Recursos linguísticos (coesão e coerência) e progressão textual": 
      return 37;
    case "Convenções da escrita e adequação vocabular": 
      return 38;
    default:
      return 1
  }  
};

export const feriados = [
  new Date('January 1, 2024'), // Ano Novo
  new Date('February 25, 2024'), // Carnaval
  new Date('February 26, 2024'), // Quarta-feira de Cinzas
  new Date('April 21, 2024'), // Dia de Tiradentes
  new Date('May 1, 2024'), // Dia do Trabalho
  new Date('September 7, 2024'), // Dia da Independência
  new Date('October 12, 2024'), // Dia de Nossa Senhora Aparecida
  new Date('November 2, 2024'), // Dia de Finados
  new Date('November 15, 2024'), // Dia da Proclamação da República
  new Date('December 25, 2024'), // Natal
];

function isFeriado(date: Date) {
  return feriados.some(feriado => {
    return feriado.getDate() === date.getDate() && feriado.getMonth() === date.getMonth() && feriado.getFullYear() === date.getFullYear();
  });
}

function isDiaUtil(date: Date) {
  return !isWeekend(date) && !isFeriado(date);
}

export function contarDiasUteis(dataInicial: Date, dataFinal: Date) {
  let count = 0;

  const currentDate = new Date(dataInicial);
  const customFinalDate:Date = new Date(dataFinal);

  while (currentDate <= customFinalDate) {
    if (isDiaUtil(currentDate)) {
      count++;
    }

    currentDate.setDate(currentDate.getDate() + 1);
  }

  return count;
}